import { Annotations } from '@pdftron/webviewer'

import LocalStorageWrapper from '~/lib/LocalStorageWrapper'
import { standardToleranceAnnotationProperties } from '../PreviewPanel/PreviewItem/PDFViewer/StandardTolerancesAnnotation'
import { CertificateOfConformanceProperties } from '../PreviewPanel/PreviewItem/PDFViewer/CertificateOfConformanceNote'
import { MaterialCertificationAnnotationProperties } from '../PreviewPanel/PreviewItem/PDFViewer/MaterialCertificationNote'

export function fetchToleranceAnnotation(
    allAnnotation: Annotations.Annotation[],
) {
    return allAnnotation.filter((annotation: Annotations.Annotation) => {
        if (annotation.Subject === 'ToleranceAnnotation') {
            return true
        }
    })
}

export function fetchStandardToleranceAnnotation(
    allAnnotation: Annotations.Annotation[],
) {
    return allAnnotation.filter(
        (annotation: Annotations.Annotation) =>
            annotation.Subject ===
            standardToleranceAnnotationProperties.subject,
    )
}
export function fetchCertificateOfConformanceAnnotation(
    allAnnotation: Annotations.Annotation[],
) {
    return allAnnotation.filter(
        (annotation: Annotations.Annotation) =>
            annotation.Subject === CertificateOfConformanceProperties.subject,
    )
}

export function fetchMaterialCertificationAnnotation(
    allAnnotation: Annotations.Annotation[],
) {
    return allAnnotation.filter(
        (annotation: Annotations.Annotation) =>
            annotation.Subject ===
            MaterialCertificationAnnotationProperties.subject,
    )
}

export function fetchThreadsAnnotation(
    allAnnotation: Annotations.Annotation[],
) {
    return allAnnotation.filter((annotation: Annotations.Annotation) => {
        if (annotation.Subject === 'ThreadAnnotation') {
            return true
        }
    })
}

export function fetchInspectionPointsAndRedactionBoxes(
    allAnnotation: Annotations.Annotation[],
    annotationSubject: string,
) {
    return allAnnotation.filter((annotation: Annotations.Annotation) => {
        if (annotation.Subject === annotationSubject) {
            return true
        }
    })
}

const storage = new LocalStorageWrapper()

export const getLocalStorageItem = (key: string) => storage.getItem(key)

export const setLocalStorageItem = (
    key: string,
    value: string | boolean | number,
) => storage.setItem(key, value)
